export default {
  functionKey: "NBCAR",
  title: "NBCAR",
  group: "Organisation",
  origin: [],
  target: [],
  description: "Compte le nombre de caractères dans une cellule",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const code = `${destination} = ${origin}.length;`;
    return { displayCode: code, safeCode: code };
  }
}
